export const FormatDate = (date) => {
    // split year month and date (yyyy-mm-dd)
    date = date.split("-"); 

    // take last two digit of year (yyyy -> yy)
    const year = String(date[0].split("")[2]) + String(date[0].split("")[3]);

    // return filter date format (mm-dd-yy)
    return `${date[1]}-${date[2]}-${year}`;
}